import React from 'react';
import { normalizeMotion } from '../constants/motionEffects';

/** O loop fica no miolo, para a barra de edição do palco não balançar junto. */
export default function MotionStage({ content, children }) {
  const motion = normalizeMotion(content);
  if (motion.loop === 'none') return children;
  return <div className={`madri-motion madri-motion--${motion.loop} madri-motion__loop`}>{children}</div>;
}